import axios from "axios";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Grid from "../../common/grid";
import "./fiscal.scss";
import { LangContext } from "../../context/LangContext";

function InterestRateFiscalWise() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const { slug } = useParams(); // Removed null

  const [interest, setInterest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const API_URL = `${process.env.REACT_APP_URL}fiscal_year_wise_interest/`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(false);
      try {
        const response = await axios.get(API_URL);
        setInterest(response.data.items);
      } catch (err) {
        console.error("Error fetching interest data:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  const getExtensionFromUrl = (url) => {
    const match = url?.match(/\.([0-9a-z]+)(?:[\?#]|$)/i);
    return match ? match[1] : "";
  };

  const isSpecialExtension = (url, extensionsArray) => {
    const ext = getExtensionFromUrl(url);
    return extensionsArray.includes(ext);
  };

  const mainData = useMemo(() => {
    if (!interest) return [];
    return nep ? interest.np : interest.en;
  }, [interest, nep]);

  const supportedExtensions = [
    "doc",
    "docx",
    "pdf",
    "ppt",
    "rtf",
    "swf",
    "txt",
    "xls",
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Something went wrong. Please try again later.</p>;

  return (
    <div className="InsidePageContainer interestsss">
      <div className="memberb-box">
        <div className="wrapper">
          <div className="member-container">
            {mainData.length === 0 ? (
              <p>No Content Found</p>
            ) : (
              <Tabs>
                <TabList>
                  {mainData.map((cat, index) => (
                    <Tab key={index}>{cat.title}</Tab>
                  ))}
                </TabList>

                {mainData.map((cat, index) => (
                  <TabPanel key={index}>
                    <section>
                      {cat.interest_rates.length === 0 ? (
                        <p>No Content Found</p>
                      ) : (
                        cat.interest_rates.map((interestItem) => (
                          <Grid
                            key={interestItem.id}
                            grid={interestItem}
                            pdf={
                              isSpecialExtension(
                                interestItem.doc,
                                supportedExtensions
                              )
                                ? interestItem.doc
                                : undefined
                            }
                            url={
                              !isSpecialExtension(
                                interestItem.doc,
                                supportedExtensions
                              )
                                ? ""
                                : undefined
                            }
                          />
                        ))
                      )}
                    </section>
                  </TabPanel>
                ))}
              </Tabs>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InterestRateFiscalWise;
